export const LogAction = {
  Login: 'login',
  Logout: 'logout',
  ChangeObservatory: 'changeObservatory',
} as const;

export type LogAction = (typeof LogAction)[keyof typeof LogAction];
